<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item
        v-for="(item, index) in pageMeta.breadcrumb"
        :key="index"
      >
        <router-link :to="{ name: item.name }">{{ item.title }}</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>{{ pageMeta.title }}</el-breadcrumb-item>
    </el-breadcrumb>
    <h1 class="view-head">
      {{pageMeta.title}}
      <div class="title-btn">
        <el-button type="warning" plain @click="onBatchOperation">批量操作</el-button>
      </div>
    </h1>
    <div class="view-content">
      <el-card class="box-card" style="margin-bottom: 20px;">
        <span>是否映射:</span>
        <el-select v-model="is_broker" size="small" style="margin-left: 10px;width: 100px;">
          <el-option label="全部" value="0">
          </el-option>
          <el-option label="已映射" value="1">
          </el-option>
          <el-option label="未映射" value="2">
          </el-option>
        </el-select>
        <el-button type="primary" size="small" style="margin-left: 10px;" @click="onSeek">查找</el-button>
      </el-card>

      <el-card class="box-card">
        <div class="table-tool">共{{totalCount}}条</div>
        <el-table
          v-loading="loading"
          :data="tableData"
          style="width: 100%">
          <el-table-column
            prop="email_client_name"
            label="商业公司名称">
          </el-table-column>
          <el-table-column
            prop="email_address"
            label="邮箱">
          </el-table-column>
          <el-table-column
            prop="broker_code"
            label="经销商编码">
          </el-table-column>
          <el-table-column
            prop="broker_name"
            label="经销商名称">
          </el-table-column>
          <el-table-column
            label="操作"
            width="180">
            <template slot-scope="scope">
              <el-button
                @click.native.prevent="openDialog(scope.$index,scope.row)"
                type="text"
                size="small">
                选择经销商
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="block" v-if="totalPage>1">
          <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="20"
            layout="prev, pager, next, jumper"
            :total="totalCount">
          </el-pagination>
        </div>
      </el-card>
    </div>
    <!--    选择经销商-->
    <choose-dealer ref="chooseDealer" @saveChange="clientAddSaveChange" :is-checkbox="false"
                   :is-clear-search-text="true" :type="5"></choose-dealer>
  </div>
</template>

<script>
  import { emailConnectList ,setBrokerClient} from '@/api/index';
  import ChooseDealer from '@/components/ChooseDealer';
  export default {
    name: "BusinessMapping",
    beforeCreate() {
      this.pageMeta = this.$route.meta;
    },
    components: {
      ChooseDealer
    },
    data: () => ({
      btnLoading:false,
      loading:false,
      find_value:'',
      emailList:[],
      dealerList:{},
      tableData:[],
      currentPage: 1,
      totalCount: 0,
      totalPage: 0,
      is_broker:'0',
      email_connect_id:'',
      changeClientRow: {
        index: '',
        row: ''
      },
    }),
    created(){
      this.getList(1);
    },
    methods:{
      getList(page){
        /*emailConnectList(this.is_broker,page).then(res=>{
          if(res.status == 0){
            this.loading = false;
            if (0 === res.status) {
              this.tableData = res.data.list;
              this.totalCount = res.data.totalCount;
              this.currentPage = parseInt(res.data.currentPage);
              this.totalPage = res.data.totalPage;
            } else {
              this.tableData = [];
              this.currentPage = 1;
              this.totalCount = 0;
              this.totalPage = 0;
            }
          }
        });*/
      },
      onSeek(){
        this.loading = true;
        this.getList(1);
      },
      openDialog(index,row){
        this.email_connect_id = row.email_connect_id;
        this.changeClientRow = {
          index,
          row
        };
        this.$refs.chooseDealer.openDialog();
      },
      handleCurrentChange(val) {
        this.dealerList = val;
        this.getList(val);
      },
      //批量操作
      onBatchOperation(){
        this.$router.push({name:'mailFetchingBatchOperation',params:{}})
      },
      clientAddSaveChange(selectionVal) {
        const clientInfo = selectionVal[0];
        let parameter = {
          broker_code:clientInfo.client_code,
          broker_name:clientInfo.client_name,
          email_connect_id:this.email_connect_id,
        };
        setBrokerClient(parameter).then(res=>{
          this.loading = false;
          if (0 === res.status) {
            this.getList(1);
            this.$message({
              message: res.msg,
              type: 'success'
            });
            this.find_value = '';
            this.emailList = [];
          } else {
            this.$message.error(res.msg);
          }
        });
      },
    }
  }
</script>

<style scoped lang="less">

</style>